import moment from 'moment'
import { Scalars } from 'types/graphqlTypes'

export const getHumanizedDuration = (dateTime: Scalars['ISO8601DateTime']) => {
  moment.updateLocale('en', {
    relativeTime: {
      past: '%s ago',
      s: '0m',
      ss: '0m',
      m: '1m',
      mm: '%dm',
      h: '1h',
      hh: '%dh',
      d: '1d',
      dd: '%dd',
      w: '1w',
      ww: '%dw',
      M: '1M',
      MM: '%dM',
      y: '1y',
      yy: '%dy',
    },
  })
  const duration = moment.duration(moment(dateTime).diff(moment())).humanize(true)
  moment.updateLocale('en', null) // moment.updateLocale changes the global locale so we need to reset it
  return duration
}
